<template>
  <div>
    <div class="table-link" @click="onOpenDialog">查看链接</div>
    <el-dialog v-if="dialogVisible" title="查看链接" width="540px" :visible.sync="dialogVisible" modal-append-to-body
      append-to-body class="dialog" :footer="null">
      <div class="content">
        <div class="content-title">小程序路径</div>
        <div class="content-link"><span>{{ url }}</span>
          <div class="content-copy" v-clipboard:copy="url" v-clipboard:success="onCopy" v-clipboard:error="onError">
            复制
          </div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>


import { matchFractionalPart1 } from "@/utils/regExp";

export default {
  props: {
    row: {
      // 行数据
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      url: '',
      dialogVisible: false, // 显示弹框

    };
  },
  methods: {
    // 复制订单信息
    onCopy() {
      this.$message.success('复制成功！')
    },
    // 复制失败
    onError() {
      this.$message.success('复制失败！')
    },
    // 打开弹框
    onOpenDialog() {
      this.url = 'pages/movie/movie?promoteCode=' + this.row.code;
      this.dialogVisible = true;
    },
    // 取消
    onCancel() {
      this.dialogVisible = false;
    },


  },
};
</script>
<style lang="less" scoped>
.content {


  &-title {
    color: #222222;
    margin-bottom: 10px;
  }

  &-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background: #F9F9F9;
    border-radius: 4px;
  }

  &-copy {
    width: 40px;
    height: 23px;
    border-radius: 2px;
    border: 1px solid #3D9EFC;
    line-height: 23px;
    color: #3D9EFC;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/promotionManage/LinkDetail.vue